export default from './CustomNumberInput';



// WEBPACK FOOTER //
// ./src/sharedComponents/InputWithSlider/components/CustomNumberInput/index.js